import {DatabaseURL} from "../../App";
import {errorActions} from "../ErrorHandler/errorHandler";
import api from "../../util/api";

export const actionTypes = {
    getDropdown1: "getDropdown1",
    getDropdown2: "getDropdown2",
    getDropdown3: "getDropdown3",
    getTrackInfo: "getTrackInfo",
    getNetgraph: "getNetgraph",
    getNetgraphConfig: "getNetgraphConfig",
    getDetails: "getDetails",
    setNetgraphLoadingData: "setNetgraphLoadingData",
    setNetgraphLoadingConfig: "setNetgraphLoadingConfig",
    setLoadingDetails: "setLoadingDetails",
    setIsLoadingTrackInfo: "setIsLoadingTrackInfo",
    getTrackVideos: "getTrackVideos",
    clearTrackPage: "clearTrackPage",
    clearDetails: "clearDetails",
};

const initialDetails = {
    infoVideo: null,
    videosFromSpeaker: null,
    videosCurrentSelection: null,
    videosCurrentTrack: null,
    videosInOtherTracks: null,
};

const initialTrackPageState = {
    trackInfo: {},
    dropdown1: [],
    dropdown2: [],
    dropdown3: [],
    netGraphData: [],
    netgraphConfig: {},
    netgraphTrackError: {},
    details: initialDetails,
    detailsError: {},
    isLoadingNetgraphData: true,
    isLoadingNetgraphConfig: true,
    isLoadingExploreDetails: false,
    isLoadingTrackInfo: true,
    trackVideos: [{}],
};

export const trackPageReducer = (state = initialTrackPageState, action) => {
    switch (action.type) {
        case actionTypes.getTrackInfo: {
            const {trackInfo} = action.payload;
            return {
                ...state,
                trackInfo,
            };
        }

        case actionTypes.getDropdown1: {
            const {dropdown1} = action.payload;
            return {
                ...state,
                dropdown1,
                details: initialDetails,
            };
        }
        case actionTypes.getDropdown2: {
            const {dropdown2} = action.payload;
            return {
                ...state,
                dropdown2,
                details: initialDetails,
            };
        }
        case actionTypes.getDropdown3: {
            const {dropdown3} = action.payload;
            return {
                ...state,
                dropdown3,
                details: initialDetails,
            };
        }
        case actionTypes.getNetgraph: {
            const {netGraphData, netgraphTrackError} = action.payload;

            return {
                ...state,
                netGraphData,
                netgraphTrackError,
                details: initialDetails,
            };
        }

        case actionTypes.getNetgraphConfig: {
            const {netgraphConfig} = action.payload;
            return {
                ...state,
                netgraphConfig,
            };
        }

        case actionTypes.getDetails: {
            const {details, detailsError} = action.payload;
            return {
                ...state,
                details,
                detailsError,
            };
        }

        case actionTypes.getTrackVideos: {
            const {trackVideos} = action.payload;
            return {
                ...state,
                trackVideos,
            };
        }

        case actionTypes.setNetgraphLoadingData: {
            const {isLoadingNetgraphData} = action.payload;
            return {
                ...state,
                isLoadingNetgraphData,
            };
        }

        case actionTypes.setNetgraphLoadingConfig: {
            const {isLoadingNetgraphConfig} = action.payload;
            return {
                ...state,
                isLoadingNetgraphConfig,
            };
        }

        case actionTypes.setLoadingDetails: {
            const {isLoadingExploreDetails} = action.payload;
            return {
                ...state,
                isLoadingExploreDetails,
            };
        }

        case actionTypes.setIsLoadingTrackInfo: {
            const {isLoadingTrackInfo} = action.payload;
            return {
                ...state,
                isLoadingTrackInfo,
            };
        }

        case actionTypes.clearDetails: {
            return {
                ...state,
                details: initialDetails,
                detailsError: {},
            };
        }

        case actionTypes.clearTrackPage: {
            return initialTrackPageState;
        }

        default:
            return state;
    }
};

const setLoadingNetgraphData = bool => ({
    type: actionTypes.setNetgraphLoadingData,
    payload: {
        isLoadingNetgraphData: bool,
    },
});

const setLoadingNetgraphConfig = bool => ({
    type: actionTypes.setNetgraphLoadingConfig,
    payload: {
        isLoadingNetgraphConfig: bool,
    },
});

const setLoaderDetails = bool => ({
    type: actionTypes.setLoadingDetails,
    payload: {
        isLoadingExploreDetails: bool,
    },
});

const _setIsLoadingTrackInfo = bool => ({
    type: actionTypes.setIsLoadingTrackInfo,
    payload: {isLoadingTrackInfo: bool},
});

export const trackPageActions = {
    getTrackInfo: trackId => dispatch => {
        dispatch(_setIsLoadingTrackInfo(true));
        return api
            .get(`v2/api/tracks/${trackId}`, {
                method: "GET",
            })
            .then(({data: {data = [{}]}}) => {
                dispatch({
                    type: actionTypes.getTrackInfo,
                    payload: {
                        trackInfo: data || {},
                    },
                });

                dispatch({
                    type: actionTypes.getTrackVideos,
                    payload: {trackVideos: data?.videos},
                });
                dispatch(_setIsLoadingTrackInfo(false));
            })
            .catch(err => {
                console.error(err);
                dispatch(_setIsLoadingTrackInfo(true));

                dispatch(errorActions.setErrorMessage(err.message));
            });
    },
    getNetgraphData: ({trackId, dropdown1 = null, dropdown2 = null, dropdown3 = null, language}) => dispatch => {
        const data = {
            dropdown1,
            dropdown2,
            dropdown3,
            language,
        };
        dispatch(setLoadingNetgraphData(true));
        if (dropdown1 && !dropdown2 && !dropdown3) {
            return api
                .post(`v2/api/tracks/${trackId}/explore/netgraph`, data, {
                    method: "POST",
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Content-Type": "application/json; charset=utf-8",
                    },
                })
                .then(({data}) => {
                    if (data && data.data) {
                        const dropdown1 = data.data.dropdown1 || [];
                        const dropdown2 = data.data.dropdown2 || [];
                        const netgraph = data.data.netgraph || [];

                        dispatch({
                            type: actionTypes.getNetgraph,
                            payload: {
                                netGraphData: netgraph,
                                netgraphTrackError: {},
                            },
                        });
                        dispatch({
                            type: actionTypes.getDropdown1,
                            payload: {
                                dropdown1,
                            },
                        });
                        dispatch({
                            type: actionTypes.getDropdown2,
                            payload: {
                                dropdown2,
                            },
                        });
                        setTimeout(() => {
                            dispatch(setLoadingNetgraphData(false));
                        }, 1000);
                    } else if (data && data.message) {
                        const message = data.message;

                        dispatch({
                            type: actionTypes.getNetgraph,
                            payload: {
                                netGraphData: [],
                                netgraphTrackError: message[0],
                            },
                        });
                        setTimeout(() => {
                            dispatch(setLoadingNetgraphData(false));
                        }, 1000);
                    } else {
                        const message = {
                            text: "Back returned error without message.",
                            type: "light",
                        };

                        dispatch({
                            type: actionTypes.getNetgraph,
                            payload: {
                                netGraphData: [],
                                netgraphTrackError: message,
                            },
                        });
                        setTimeout(() => {
                            dispatch(setLoadingNetgraphData(false));
                        }, 1000);
                    }
                })
                .catch(err => {
                    dispatch(errorActions.setErrorMessage(err.message));
                    dispatch(setLoadingNetgraphData(false));
                });
        } else if (dropdown1 && dropdown2 && !dropdown3) {
            return api
                .post(`v2/api/tracks/${trackId}/explore/netgraph`, data, {
                    method: "POST",
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Content-Type": "application/json; charset=utf-8",
                    },
                })
                .then(
                    ({
                        data: {
                            message = [{}],
                            data: {dropdown3 = [], netgraph = []},
                        },
                    }) => {
                        dispatch({
                            type: actionTypes.getNetgraph,
                            payload: {
                                netGraphData: netgraph,
                                netgraphTrackError: !netgraph
                                    ? {
                                          type: "warning",
                                          text: "Data not found",
                                      }
                                    : message[0],
                            },
                        });
                        dispatch({
                            type: actionTypes.getDropdown3,
                            payload: {
                                dropdown3,
                            },
                        });
                        setTimeout(() => {
                            dispatch(setLoadingNetgraphData(false));
                        }, 1000);
                    }
                )
                .catch(err => {
                    dispatch(errorActions.setErrorMessage(err.message));
                    dispatch(setLoadingNetgraphData(false));
                });
        }
    },

    getNetgraphConfig: type => dispatch => {
        dispatch(setLoadingNetgraphConfig(true));

        return api
            .get(`${DatabaseURL}/api/component/${type}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then(({data}) => {
                dispatch({
                    type: actionTypes.getNetgraphConfig,
                    payload: {
                        netgraphConfig: data.data[0].config,
                    },
                });
                dispatch(setLoadingNetgraphConfig(false));
            })
            .catch(err => {
                dispatch(errorActions.setErrorMessage(err.message));
                dispatch(setLoadingNetgraphConfig(false));
            });
    },
    getDetails: ({trackId, filter2IDs, feature_id, speaker_id, video_id, topic_id}) => dispatch => {
        dispatch(setLoaderDetails(true));
        dispatch({
            type: actionTypes.clearDetails,
        });

        const dataToSend = {
            selection: filter2IDs || null,
            feature_id: feature_id || null,
            speaker_id: speaker_id || null,
            video_id: video_id || null,
            topic_id: topic_id || null,
        };

        return api
            .post(`v2/api/tracks/${trackId}/explore/detail`, dataToSend, {
                method: "POST",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then(({data: {data = {}, message = [{}]}}) => {
                const someFound =
                    (data.infoVideo && data.infoVideo.id) ||
                    (data.videosFromSpeaker && data.videosFromSpeaker.length) ||
                    (data.videosCurrentSelection && data.videosCurrentSelection.length) ||
                    (data.videosCurrentTrack && data.videosCurrentTrack.length) ||
                    (data.videosInOtherTracks && data.videosInOtherTracks.length);

                if (someFound) {
                    dispatch({
                        type: actionTypes.getDetails,
                        payload: {
                            details: data,
                            detailsError: message && message[0],
                        },
                    });
                } else {
                    dispatch({
                        type: actionTypes.getDetails,
                        payload: {
                            details: {},
                            detailsError: {
                                type: "warning",
                                text: "ERROR.VIDEOS.NOT_FOUND",
                            },
                        },
                    });
                }
                dispatch(setLoaderDetails(false));
            })
            .catch(err => {
                dispatch({
                    type: actionTypes.getDetails,
                    payload: {
                        details: {},
                        detailsError: {
                            type: "danger",
                            text: err.message,
                        },
                    },
                });
                dispatch(setLoaderDetails(false));
            });
    },

    clearDetails: () => dispatch =>
        dispatch({
            type: actionTypes.clearDetails,
        }),

    clearTrackPage: () => dispatch =>
        dispatch({
            type: actionTypes.clearTrackPage,
        }),
};
